import { render, staticRenderFns } from "./KeyTen.vue?vue&type=template&id=6571dbd4&scoped=true&"
import script from "./KeyTen.vue?vue&type=script&lang=js&"
export * from "./KeyTen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6571dbd4",
  null
  
)

export default component.exports